
interface FormReadOnlyElementProps {
  label: string;
  value?: string | number;
  onClick?: () => void;
  id?: string;
}

const FormReadOnlyElement = ({ label, value, onClick, id }: FormReadOnlyElementProps) => {
  return (
    <div className="flex gap-2.5 flex-col">
      <small className="text-cool-gray-500">{label || ''}</small>
      {!onClick && <p id={id}>{value || '-'}</p>}
      {onClick && <a onClick={onClick}>{value || '-'}</a>}
    </div>
  );
};

export default FormReadOnlyElement;
